<template>
  <div
    class="lesson-description-component row flex-column flex-md-row mb-4 mx-n3 pt-4"
  >
    <div class="px-3 col-12 col-lg-8 order-2 order-lg-1 mb-4">
      <h4 class="title mb-2">{{ title }}</h4>
      <p class="lesson-description mb-4">
        <span v-html="description"></span>
        <span
          class="cursor-pointer"
          v-if="description && description.length > limit_count"
          @click="truncated_description = !truncated_description"
        >
          {{ `ver ${truncated_description ? "mais" : "menos"}` }}
        </span>
      </p>
      <star-rating v-if="!isQuiz" />
    </div>

    <div
      class="px-3 col-12 col-lg-4 order-1 order-lg-2 w-mobile-100 mb-4 mb-lg-0"
    >
      <div class="row">
        <div class="col-6 pr-lg-1 mb-3 mb-lg-0">
          <router-link
            v-if="previousContent"
            :to="previousRoute"
            class="btn btn-block btn-next"
            :class="{ disabled: !previousContent }"
          >
            <i class="icon-chevron-left mr-2" /> Anterior
          </router-link>
        </div>
        <div class="col-6 pl-lg-1 mb-3 mb-lg-0">
          <router-link
            v-if="nextContent"
            :to="nextContent.is_blocked.status ? {} : nextRoute"
            class="btn btn-block btn-next"
            :class="{ disabled: !nextContent || nextContent.is_blocked.status }"
          >
            Próximo <i class="icon-chevron-right ml-2" />
          </router-link>
        </div>
      </div>
      <button
        v-if="!hideFinishButton"
        class="btn w-mobile-100 text-done px-0 mx-0 text-center"
        @click="$emit('toggleFinished')"
      >
        <loading :show="loadingFinish" small>
          <div
            v-if="finishedLesson"
            class="text-success d-flex align-items-center"
          >
            <div class="check-wrapper  mr-2">
              <i class="icon-check border-success" />
            </div>
            Concluída
          </div>
          <div v-else class="d-flex align-items-center">
            <span class="circle mr-2"></span>
            Marcar como concluída
          </div>
        </loading>
      </button>
    </div>
  </div>
</template>

<script>
import StarRating from "@/components/lesson/StarRating";
export default {
  components: { StarRating },
  props: {
    finishedLesson: Boolean,
    hideFinishButton: Boolean,
    content: Object,
    loadingFinish: Boolean,
    nextContent: {
      type: Object,
      default: () => {}
    },
    previousContent: {
      type: Object,
      default: () => {}
    },
    isQuiz: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      truncated_description: true,
      limit_count: 175
    };
  },
  computed: {
    title() {
      if (this.isQuiz) return this.content.title;
      return this.content.name;
    },
    description() {
      const description = `${this.content.description || ""}`;
      const limit = this.truncated_description
        ? this.limit_count
        : description.length;
      const ellipsis = description.length > limit ? "..." : "";
      return `${description}`.slice(0, limit) + `${ellipsis}`;
    },
    nextRoute() {
      if (!this.nextContent) return {};

      if (this.itemIsQuiz(this.nextContent)) {
        return {
          name: "lesson-quiz",
          params: {
            id: this.nextContent.module.id,
            quiz: this.nextContent.code
          }
        };
      }
      return {
        name: "lesson",
        params: {
          id: this.nextContent.module.id,
          lesson: this.nextContent.id
        }
      };
    },
    previousRoute() {
      if (!this.previousContent) return {};

      if (this.itemIsQuiz(this.previousContent)) {
        return {
          name: "lesson-quiz",
          params: {
            id: this.previousContent.module.id,
            quiz: this.previousContent.code
          }
        };
      }
      return {
        name: "lesson",
        params: {
          id: this.previousContent.module.id,
          lesson: this.previousContent.id
        }
      };
    }
  },
  methods: {
    itemIsQuiz(item) {
      return (
        item.type == "quiz" ||
        ["approval_average", "time_limit_minutes", "number_of_attempts"].reduce(
          (acc, cur) => acc && Object.keys(item).includes(cur),
          true
        )
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.lesson-description-component {
  .title {
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }

  .lesson-description {
    color: var(--verso-dark-grey-1);
    font-feature-settings: "clig" off, "liga" off;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;

    ::v-deep span *:last-child {
      display: inline !important;
    }

    div {
      color: var(--verso-dark-grey-1) !important;
    }
  }

  .cursor-pointer {
    cursor: pointer;
    color: #3e56ac;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
  }
  .text-done {
    font-weight: 400;
  }

  .circle,
  .icon-check {
    flex-shrink: 0;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  button {
    i {
      font-size: 22px;
    }
  }
  .btn.disabled {
    opacity: 0.3;
  }

  .check-wrapper {
    width: 20px;
    height: 20px;
    background-color: #62ad3e;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    flex-shrink: 0;
    .icon-check {
      flex-shrink: 0;
    }
  }

  .row:has(.btn-next) {
    @media screen and (min-width: 992px) {
      .btn-next {
        padding: 2px 0;
        min-height: 40px;
      }
    }
  }
}
</style>
